import { render, staticRenderFns } from "./cSocMedia.vue?vue&type=template&id=44c810ae&scoped=true&"
import script from "./cSocMedia.vue?vue&type=script&lang=js&"
export * from "./cSocMedia.vue?vue&type=script&lang=js&"
import style0 from "./cSocMedia.vue?vue&type=style&index=0&id=44c810ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c810ae",
  null
  
)

export default component.exports